import { useState } from "react";
import { useApi } from "src/api";
import { Button } from "src/elements";
import { downloadFile } from "src/utils/downloadFile";

interface Props {
  merchflowId: number;
  s1UserTriggerId: number;
  templateId: string;
}

export const S1LogsButton = ({ merchflowId, s1UserTriggerId, templateId }: Props) => {
  const { getMerchflowS1PreLogsApi, getMerchflowS1LogsApi } = useApi();

  // Loading with state, because all stores page has many logs buttons, need to show spinner only for the one button.
  const [isLoading, setIsLoading] = useState(false);

  const downloadLogs = async (logsType: "get_features" | "get_containers") => {
    setIsLoading(true);

    let response;
    let filename;
    switch (logsType) {
      case "get_features":
        response = await getMerchflowS1PreLogsApi(merchflowId, s1UserTriggerId);
        filename = `pre_s1_logs_${merchflowId}_${s1UserTriggerId}`;
        break;
      case "get_containers":
        response = await getMerchflowS1LogsApi(merchflowId, s1UserTriggerId, templateId);
        filename = `s1_logs_${merchflowId}_${s1UserTriggerId}_${templateId}`;
        break;
    }

    if (response) {
      downloadFile({
        name: filename,
        extension: "json",
        data: JSON.stringify(response),
      });
    }
    setIsLoading(false);
  };

  return (
    <Button
      color="greenSmoke"
      variant="inverted"
      dropdown={[
        { label: "Pre S1 (get_features)", onClick: () => downloadLogs("get_features") },
        { label: "S1 (get_containers)", onClick: () => downloadLogs("get_containers") },
      ]}
      isLoading={isLoading}
    >
      Logs
    </Button>
  );
};
